<template>

    <!-- form title -->
    <h2 v-if="this.formTitle" class="mb-3 text-center h2" v-html="this.formTitle"></h2>

    <!-- simple progress bar. it is configured in Application.vue in applicationSettings.progressBar -->
    <ProgressBar v-if="!!this.applicationSettings.progressBar.active"
        v-model:application-settings="this.applicationSettings" />

    <!-- lets loop through the entire array of steps declared in the JS file provided for this form -->
    <div v-for="(step, index) in this.formData.steps" :key="index">

<!--        <div v-if="step.topTitle && this.activeStepIndex == 0" v-html="this.getTranslatedText(step.topTitle, 'steps.titles')"></div>-->

        <!-- title shown at the top of the step -->
        <template v-if="!!step.topTitle && this.activeStepIndex == 0" >
            <template v-if="typeof step.topTitle == 'function'">
                <div v-if="step.topTitle({...this.app}) != false" v-html="this.getTranslatedText(step.topTitle({...this.app}), 'steps.titles')"></div>
            </template>
            <div v-else v-html="this.getTranslatedText(step.topTitle, 'steps.titles')"></div>
        </template>

        <!-- step -->
        <Transition name="fade" mode="out-in">

            <div class="" v-if="index === this.activeStepIndex" @click="this.handleUserFormInteraction()">

                <!-- step title -->
<!--                <h3 v-if="step.title && step.title.length > 0" class="my-4 text-center h4" v-html="step.title"></h3>-->
                <h3 v-if="step.title && step.title.length > 0" class="my-4 text-center h4" v-html="this.getTranslatedText(step.title, 'steps.titles')"></h3>

                <!-- edit summary step -->
                <div class="" v-if="!!this.activeStep.isStepReadOnly && !!this.activeStep.isStepEditable && !this.shouldEditActiveStep">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end my-2">
                        <button v-if="!this.editActiveStep" @click.prevent="this.editActiveStep = true;" id="btnEditStep"
                            type="button" class="btn btn-sm btn-outline-secondary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                class="bi bi-pencil" viewBox="0 0 16 16">
                                <path
                                    d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z">
                                </path>
                            </svg>
                            {{ this.getTranslatedText('__edit__', 'buttons') }}
                        </button>
                    </div>
                </div>

                <!-- text shown at the top of the step -->
                <template v-if="!!step.textTop">
                    <template v-if="typeof step.textTop == 'function'">
                        <div class="mb-2" v-if="step.textTop({...this.app}) != false" v-html="this.getTranslatedText(step.textTop({...this.app}), 'steps.textTop')"></div>
                    </template>
                    <div class="mb-2"  v-else v-html="this.getTranslatedText(step.textTop, 'steps.textTop')"></div>
                </template>

                <div class="row">


                    <template v-for="(field) in step.fields" :key="field.name">
                        <!-- Force next columns to break to new line at md breakpoint and up -->
                        <div v-if="!!field.clearfixTop" class="d-none d-md-block"></div>
                        <div :class="field.fieldOuterClass ?? 'col-md-12'">
                            <hr v-if="!!field.dividerTop" class="border border-secondary border-1 opacity-40">

                            <template v-if="!!field.textTop">
                                <template v-if="typeof field.textTop == 'function'">
                                    <h3 v-if="field.textTop({...this.app}) != false" v-html="this.getTranslatedText(field.textTop({...this.app}), 'fields.textTop')"></h3>
                                </template>
                                <h3 v-else v-html="this.getTranslatedText(field.textTop, 'fields.textTop')"></h3>
                            </template>

                            <LcField v-if="!this.isHiddenField(field)" :fieldData="field"
                                @goToNextStep="this.goToNextStepFromNestedComponent"
                                :fieldValidator="this.validator[field.name]"
                                :shouldValidate="this.applicationSettings.shouldValidateForm"
                                :inputColor="this.applicationSettings.formStyle.inputColor"
                                :isStepReadOnly="step.isStepReadOnly && !this.editActiveStep && !this.shouldEditActiveStep"
                                :isStepEditable="step.isStepEditable && !!this.editActiveStep && !!this.shouldEditActiveStep"
                            />

                            <hr v-if="!!field.dividerBottom" class="border border-secondary border-1 opacity-40">

                            <template v-if="!!field.textBottom">
                                <template v-if="typeof field.textBottom == 'function'">
                                    <div v-if="field.textBottom({...this.app}) != false" v-html="this.getTranslatedText(field.textBottom({...this.app}), 'fields.textBottom')"></div>
                                </template>
                                <div v-else v-html="this.getTranslatedText(field.textBottom, 'fields.textBottom')"></div>
                            </template>
                        </div>
                        <!-- Force next columns to break to new line at md breakpoint and up -->
                        <div v-if="!!field.clearfixBottom" class="d-none d-md-block"></div>
                    </template>
                </div>

                <template v-if="!!step.textBottom">
                    <template v-if="typeof step.textBottom == 'function'">
                        <div class="mt-2" v-if="step.textBottom({...this.app}) != false" v-html="this.getTranslatedText(step.textBottom({...this.app}), 'steps.textBottom')"></div>
                    </template>
                    <div class="mt-2" v-else v-html="this.getTranslatedText(step.textBottom, 'steps.textBottom')"></div>
                </template>

                <div v-if="!this.showSkipVerification">
                    <Recaptcha v-if="this.showRecaptchaVerification" @recaptchaValueChange="handleRecaptchaChange" />
                </div>

                <!-- action bottons section -->
                <div v-if="!this.activeStep.hideButtonsSection" class="row mt-2">
                    <div v-if="this.showSkipButtonsSection" class="col-6 col-md-4" style="text-align:center;">
                        <a v-if="this.showSkipRegistration && !!this.activeStep.isStepSkippable" id="btnSkip"
                            class="btn btn-lg w-100"
                            :class="'btn-' + (this.applicationSettings.formStyle.buttonColor?.skip ?? 'light')"
                            @click.prevent="this.executeUserWantsRegistrationDecision(false)">{{ this.getTranslatedText('__skip__', 'buttons') }}</a>

                        <a v-else-if="this.showSkipVerification" id="btnSkip" class="btn btn-lg w-100"
                            :class="'btn-' + (this.applicationSettings.formStyle.buttonColor?.skip ?? 'light')"
                            @click.prevent="this.executeSkipVerification()">{{ this.getTranslatedText('__skip__', 'buttons') }}</a>

                        <a v-else-if="!!this.activeStep.isStepSkippable" id="btnSkip" class="btn btn-lg w-100"
                            :class="'btn-' + (this.applicationSettings.formStyle.buttonColor?.skip ?? 'light')"
                            @click.prevent="this.goToNextStep(!!this.activeStep.isStepSkippable)">{{ this.getTranslatedText('__skip__', 'buttons') }}</a>
                    </div>

                    <div :class="this.showSkipButtonsSection ? 'col-6 col-md-4' : 'col-6 offset-3 col-md-4 offset-md-4'" style="text-align:center;">
                        <a v-if="isLastStep" class="btn btn-lg w-100"
                            :class="!!step.nextButtonClass && step.nextButtonClass.length>0 ?
                                step.nextButtonClass :
                                !this.skipRecaptcha ? 'btn-secondary disabled' : 'btn-' + (this.applicationSettings.formStyle.buttonColor?.next ?? 'primary')"
                            :disabled="!this.skipRecaptcha"
                            @click.prevent="this.skipRecaptcha ? this.executeFlowCompleted() : true">
                            {{ this.getTranslatedText(!!step.nextButtonText && step.nextButtonText.length>0 ? step.nextButtonText : this.submitButtonText, 'buttons') }}</a>
                        <a v-else id="btnNext" class="btn btn-lg w-100"
                            :class="!!step.nextButtonClass && step.nextButtonClass.length>0 ?
                                step.nextButtonClass :
                                !this.skipRecaptcha ? 'btn-secondary disabled' : 'btn-' + (this.applicationSettings.formStyle.buttonColor?.next ?? 'primary')"
                            :disabled="!this.skipRecaptcha"
                            @click.prevent="this.skipRecaptcha ? this.goToNextStep() : true">
                            {{ this.getTranslatedText(!!step.nextButtonText && step.nextButtonText.length>0 ? step.nextButtonText : '__next__', 'buttons') }}</a>
                    </div>

                </div>

                <template v-if="!!step.textBottomBelowActionButtons">
                    <template v-if="typeof step.textBottomBelowActionButtons == 'function'">
                        <div class="mt-4" v-if="step.textBottomBelowActionButtons({...this.app}) != false" v-html="this.getTranslatedText(step.textBottomBelowActionButtons({...this.app}), 'steps.textBottomBelowActionButtons')"></div>
                    </template>
                    <div class="mt-4" v-else v-html="this.getTranslatedText(step.textBottomBelowActionButtons, 'steps.textBottomBelowActionButtons')"></div>
                </template>

            </div>
        </Transition>
        <!-- /step -->

    </div>
    <!-- </form> -->
</template>

<script>

import ProgressBar from '@/components/ProgressBar.vue';
import LcField from '@/components/form/LcField.vue';
import Recaptcha from '@/components/form/Recaptcha.vue';
import { formFunctions } from '@/form/helpers/functions.js';
import { fieldValidationHelper, addressFieldValidationHelper } from "@/form/helpers/field-validations.js";

import { inject } from 'vue';
import { ref } from 'vue'

export default {
    name: 'LcForm',
    emits: ["update:application-settings", "completed"],
    setup(props) {
        // console.log('LcForm setup');
        const { app, persistLocally, updateApplication, processedApplication, getTranslatedText } = inject('app') // app is being provided in Application.vue
        const validator = ref({});

        return {
            app,
            persistLocally,
            updateApplication,
            processedApplication,
            validator,
            getTranslatedText
        }
    },
    components: {
        ProgressBar,
        LcField,
        Recaptcha
    },
    props: {
        formData: {
            type: Object,
            required: true,
        },
        applicationSettings: {
            type: Object,
            required: true,
        },
        formSettings: {
            type: Object,
            required: false,
        },
        showSkipVerification: {
            type: Boolean,
            required: false,
            default: false
        },
        showSkipRegistration: {
            type: Boolean,
            required: false,
            default: false
        },
        showRecaptchaVerification: {
            type: Boolean,
            required: false,
            default: false
        },
        formTitle: {
            type: String,
            required: false,
            // default: 'Get Your FREE Quote Today',
            default: null,
        },
        shouldEditActiveStep: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data: () => {

        // this represent the js object in the position 'activeStepIndex' of the array of steps
        // activeStep = allSteps[activeStepIndex]
        let activeStep = {};

        // fields to be hidden in case another condition is met, like a value obtained from another field from a previous step
        // i.e. hide employer if user says is unemployed
        // the hideField() method is the responsible for adding the name of fields to hide
        let hiddenFields = {};
        let hiddenFieldsIfCondition = {};

        // this variable variable helps to keep track of the step that will be considered as 'active'
        // it gets incremented in the goToNextStep() method
        // it also helps to determine if the form is considered as 'completed' (this.$emit("completed")) thanks to the checkIfLastStep() method
        let activeStepIndex = 0;
        let shouldSkipNextStep = false;

        // this variable is gonna be changed from the <Recaptcha> component
        let isRecaptchaSolved = false;

        // this variable helps to show summary steps as 'read-only' fields
        // btnEditStep changes this variable allowing the user to modify the input value
        let editActiveStep = false;

        const recaptchaKey = process.env.MIX_RECAPTCHA_SITE_V3_KEY;

        return {
            activeStep,
            activeStepIndex,
            shouldSkipNextStep,
            isRecaptchaSolved,
            editActiveStep,
            hiddenFields,
            hiddenFieldsIfCondition,
            recaptchaKey,
        };

    },
    methods: {
        isHiddenField(fieldObject) {
            return this.hideField(fieldObject);
        },
        hideField(fieldObject, onInitStep = false) {
            let hideField = false;

            if( onInitStep ) {

                if(fieldObject.hasOwnProperty('hideIfHasValue') && !!fieldObject.hideIfHasValue &&
                    this.app.hasOwnProperty(fieldObject.name) && !!this.app[fieldObject.name]) {
                    hideField = true;
                }

                this.hiddenFields[fieldObject.name] = hideField;

                // we should go to Next Step if the all the fields are hidden
                // count all current step fields
                var currentStepFieldsCount = Object.keys(this.activeStep.fields ?? {}).length;
                // count all the hidden fields
                var hiddenFieldsCount = Object.keys(this.hiddenFields ?? {}).filter(key => this.hiddenFields[key] == true).length;

                if(currentStepFieldsCount == hiddenFieldsCount) {
                    let shouldSkipValidation = true;
                    this.goToNextStepFromNestedComponent(shouldSkipValidation);
                }

            }
            else {

                if (!!fieldObject.hideIfCondition && typeof fieldObject.hideIfCondition == 'function' && fieldObject.hideIfCondition({ ...this.app }) == true) {
                    hideField = true;
                }

                this.hiddenFieldsIfCondition[fieldObject.name] = hideField;

            }

            if (this.hiddenFields.hasOwnProperty(fieldObject.name) && this.hiddenFields[fieldObject.name] == true ||
                this.hiddenFieldsIfCondition.hasOwnProperty(fieldObject.name) && this.hiddenFieldsIfCondition[fieldObject.name] == true) {
                return true;
            }
            else {
                return false;
            }

        },
        async validateForm() {
            if (!this.applicationSettings.shouldValidateForm ||
                (
                    !!this.activeStep.isStepReadOnly &&
                    this.activeStep.hasOwnProperty('isStepEditable') &&
                    this.activeStep.isStepEditable == false
                )
            ) {
                return true;
            }

            let allFields = Object.keys(this.validator);
            // console.log('allFields');
            // console.log(allFields);

            for( const field of allFields ) {
                if (this.hiddenFields.hasOwnProperty(field) && this.hiddenFields[field] == true ||
                    this.hiddenFieldsIfCondition.hasOwnProperty(field) && this.hiddenFieldsIfCondition[field] == true) {
                    this.validator[field].isValid = true;
                    this.validator[field].errorMessage = [];
                }
                else {
                    let validatorHelper = field == "address" ?
                        addressFieldValidationHelper(this.validator[field].value) :
                        fieldValidationHelper(this.validator[field], this.app);
                    this.validator[field].isValid = validatorHelper.isValid;
                    this.validator[field].errorMessage = validatorHelper.messages;

                    if(!!validatorHelper.isValid && field != "address") {
                        var emailFieldsToValidate = ['email'];
                        if(emailFieldsToValidate.includes(field)) {
                            await this.validateEmailWithLC(this.validator[field]);
                        }
                    }
                }
            }

            return this.isValidForm;
        },
        async initStep() {
            // lets skip activeStep if condition is met
            if (this.activeStep && !!this.activeStep.hideIfCondition && typeof this.activeStep.hideIfCondition == 'function' && this.activeStep.hideIfCondition({ ...this.app }) == true) {

                // we do the loading animation if the step has a loadingFunction even if the step is gonna be skipped
                await this.resolveLoadingAnimation();

                let shouldSkipValidation = true;
                this.goToNextStepFromNestedComponent(shouldSkipValidation);
                return;
            }

            await this.resolveLoadingAnimation();

            this.editActiveStep = false;

            this.hiddenFields = {};
            this.hiddenFieldsIfCondition = {};

            //validator helper
            this.validator = {};
            const currentFields = this.activeStep ? this.activeStep.fields : null;
            if (currentFields) {
                await currentFields.forEach((field) => {
                    this.validator[field.name] = {
                        value: this.app[field.name] ?? null,
                        isDirty: false,
                        isValid: false,
                        rules: field.validationRules ?? "",
                        errorMessage: [],
                        invalidAddressFields: [],
                    }

                    let onInitStep = true;
                    this.hideField(field, onInitStep);
                });
            }

            // console.log('this.validator');
            // console.log(JSON.stringify(this.validator));
        },
        async resolveLoadingAnimation() {
            if(this.activeStep && this.activeStep.loadingFunction && typeof this.activeStep.loadingFunction == 'function') {
                let loadingLogicObject = this.activeStep.loadingFunction(this.app);

                if(!!loadingLogicObject && loadingLogicObject.length > 0) {
                    // loadingFunction now accepts multiple animations per step with different durations and messages
                    for (const animation of loadingLogicObject) {
                        let animationTimeInSeconds = animation.seconds ?? null;
                        let animationMessage = animation.message ?? null;
                        if(animationTimeInSeconds) {
                            await this.doLoadingAnimation(animationTimeInSeconds, animationMessage);
                        }
                    }
                }
            }
        },
        // === START => LC FORM FUNCTIONS ===
        getFieldValue(fieldName) {
            return this.app[fieldName] ?? null;
        },
        async goToNextStep(shouldSkipValidation = false) {
            // console.log('goToNextStep');
            // debugger;

            // let's scroll to the top as the page does not refresh and remembers its last position after every step
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });

            var validatedForm = await this.validateForm();
            if (!shouldSkipValidation && !validatedForm) {
                return;
            }

            this.persistLocally();

            if (!!this.applicationSettings.partialRequestOnEveryStep && !this.isLastApplicationStep ) {
                if(this.applicationSettings.partialRequestsCount == 0) {
                    await this.executeCreatePartialApp();
                }
                else {
                    this.executeCreatePartialApp();
                }
            }

            await this.executeBeforeNextStep();
            await this.executeBeforeCreateNextStep();

            this.activeStepIndex = !!this.shouldSkipNextStep ? this.activeStepIndex + 2 : this.activeStepIndex + 1;
            this.activeStep = this.formData.steps[this.activeStepIndex];

            if (this.isLastStep) {
                this.userSelectedOption = true;
            }
            else {
                this.shouldSkipNextStep = false;
            }

        },
        async goToNextStepFromNestedComponent(shouldSkipValidation = false) {
            // console.log('goToNextStepFromNestedComponent');
            // debugger;
            if (this.isLastStep) {
                this.executeFlowCompleted(shouldSkipValidation);
            }
            else if(
                !!this.nextStep.beforeCreate
                    && typeof this.nextStep.beforeCreate == 'function'
                        && this.nextStep.beforeCreate({ ...this.app }) == 'executeEarlySubmitApplication'
            ) {
                await this.goToNextStep(true);
                await this.goToNextStep(true);
                await this.executeSubmitApplication();
            }
            else {
                this.goToNextStep(shouldSkipValidation);
            }
        },
        async executeBeforeCreateNextStep() {
            // console.log('executeBeforeCreateNextStep');
            const callbackType = this.nextStep ? typeof this.nextStep.beforeCreate : null;
            if (!callbackType) {
                return true;
            }
            // we can receive a function() or a functionName to be called within the component
            switch (callbackType) {
                case 'function':
                    // await this.nextStep.beforeCreate({ ...this.app });
                    // await this.nextStep.beforeCreate();
                    var returnedValue = await this.nextStep.beforeCreate({...this.app});
                    if(typeof returnedValue === 'string' && typeof this[returnedValue] === 'function') {
                        await this[returnedValue]();
                    }

                    break;
                case 'string':
                    await this[this.nextStep.beforeCreate]();
                    break;
            }
            return true;
        },
        checkIfLastStep() {
            if (this.activeStepIndex > this.formData.steps.length - 1) {
                this.$emit("completed", true);
            }
        },
        async executeBeforeNextStep() {
            // console.log('executeBeforeNextStep');
            const callbackType = typeof this.activeStep.beforeNextStep ?? null;
            if (!callbackType) {
                return true;
            }
            // we can receive a function() or a functionName to be called within the component
            switch (callbackType) {
                case 'function':
                    // await this.activeStep.beforeNextStep();
                     var returnedValue = await this.activeStep.beforeNextStep({...this.app});
                     if(typeof returnedValue === 'string' && typeof this[returnedValue] === 'function') {
                         await this[returnedValue]();
                     }
                    break;
                case 'string':
                    await this[this.activeStep.beforeNextStep]();
                    break;
            }
            return true;
        },
        async executeFlowCompleted(shouldSkipValidation = false) {

            var validatedForm = await this.validateForm();
            if (!shouldSkipValidation && !validatedForm) {
                return;
            }

            this.$emit("completed", true);
            this.goToNextStep();
        },
        executeSkipVerification() {
            this.applicationSettings.notifications.error = {};
            this.applicationSettings.notifications.success = {};
            this.applicationSettings.userWantsVerification = false;
        },
        executeSkipRegistration() {
            this.applicationSettings.notifications.error = {};
            this.applicationSettings.notifications.success = {};
            this.applicationSettings.userWantsVerification = false;
            this.applicationSettings.userWantsRegistration = false;
        },
        executeSkipIfAuthenticated() {
            if (!!this.applicationSettings.isUserAuthenticated) {
                let skipValidations = true;
                this.goToNextStep(skipValidations);
            }
        },
        executeClearPassword() {
            if (!this.applicationSettings.isUserAuthenticated) {
                this.app['password'] = null;
            }
        },
        initializeValuesForVerification() {
            this.activeStep = {};
            this.hiddenFields = {};
            this.hiddenFieldsIfCondition = {};
            this.activeStepIndex = 0;
            this.userSelectedOption = true;
        },
        // === END => LC FORM FUNCTIONS ===
        // === START => COMPONENTS FUNCTIONS ===
        // *** INITIAL FLOW ***
        async executeEmailRegistrationCheck() {
            // TODO -- API CALL
            this.applicationSettings.loadingAnimationSeconds = -1;

            let payload = {
                email: this.getFieldValue('email'),
                password: 'fakePassword'
            };

            let response = await formFunctions.apiLogin(payload);
            // 200 success
            // 201 token created
            // 401 check existence only
            let validStatusCodes = [200, 201, 401];
            if (!!response.statusCode && validStatusCodes.includes(response.statusCode)) {
                this.applicationSettings.isUserRegistered = true;
            } else {
                // TODO -- validate errors
                this.applicationSettings.isUserRegistered = false;
            }

            this.applicationSettings.loadingAnimationSeconds = 0;
        },
        async executeSkipIfUnregistered() {
            // console.log('executeSkipIfUnregistered');
            // console.log('this.applicationSettings.isUserRegistered');
            // console.log(!!this.applicationSettings.isUserRegistered);
            if (!this.applicationSettings.isUserRegistered) {
                if (this.activeStepIndex == (this.formData.steps.length - 1)) {
                    let shouldSkipValidation = true;
                    this.executeFlowCompleted(shouldSkipValidation);
                }
                this.shouldSkipNextStep = true;
            }
        },
        async executeEmailAuthentication() {
            // console.log('executeEmailAuthentication');
            this.applicationSettings.loadingAnimationSeconds = -1;

            let payload = {
                email: this.getFieldValue('email'),
                password: this.getFieldValue('password')
            };

            let response = await formFunctions.apiLogin(payload);
            if (!!response.member) {
                // formFunctions.portalLogin(Object.assign(payload, {baseUrl:this.applicationSettings.portalBaseUrl}));
                this.applicationSettings.isUserAuthenticated = true;
                this.applicationSettings.isUserVerified = !!response.member.is_verified;

                this.updateApplication(response.member);
            } else {
                // TODO -- validate errors
                this.applicationSettings.isUserAuthenticated = false;
                this.applicationSettings.isUserVerified = false;
            }

            this.applicationSettings.loadingAnimationSeconds = 0;
        },
        async executeCreateAccount() {
            // console.log('executeCreateAccount');
            this.applicationSettings.loadingAnimationSeconds = -1;

            if (
                this.app.wants_to_create_account && this.app.wants_to_create_account == 'yes' &&
                this.app.password && this.app.password.length > 0 &&
                this.app.password_confirmation && this.app.password_confirmation.length > 0 &&
                this.app.password == this.app.password_confirmation
                && (
                    !this.app.forcePhoneVerification ||
                    (this.app.verified_phone_number && this.app.verified_phone_number.length == 10)
                )
            ) {

                let payload = { ...this.app };

                let response = await formFunctions.apiCreateAccount(payload);
                if (!!response.member) {
                    this.applicationSettings.isUserAuthenticated = true;
                    this.updateApplication(response.member);
                } else {
                    // TODO -- validate errors
                    this.applicationSettings.isUserAuthenticated = false;
                    this.applicationSettings.userWantsVerification = false;
                }
            }
            else {
                this.applicationSettings.isUserAuthenticated = false;
                this.applicationSettings.userWantsVerification = false;
            }

            this.applicationSettings.loadingAnimationSeconds = 0;
        },
        async executeSubmitApplication() {
            // console.log('executeSubmitApplication');
            this.applicationSettings.loadingAnimationSeconds = -1;

            // we are not using/validating the recaptcha token anymore
            // const submitToken = await this.getToken('submit');

            let extraFields = {
                createPortalApp: !!this.applicationSettings.isUserAuthenticated,
                userAuthentication: {
                    status: !!this.applicationSettings.isUserAuthenticated,
                    email: this.getFieldValue('email'),
                    password: this.getFieldValue('password'),
                },
                shouldRequestCreditScore: this.applicationSettings.isUserAuthenticated && this.applicationSettings.isUserVerified,
                is_partial: false,
                // gr_token: submitToken ?? null,
                prepop_token: this.app.token ?? null,
            };

            // before submission lets load the animation if Flinks was completed
            if(this.app.completed_flinks && this.app.completed_flinks == 'yes') {
                await this.doLoadingAnimation(5);
            }

            let payload = { ...this.app, ...extraFields };

            let response = await formFunctions.apiSubmitApplication(payload);
            if (!!response.application) {
                this.updateApplication(response.application);
            }
            if (!!response.processedApplication) {
                this.processedApplication = response.processedApplication ?? {};
            }

            this.applicationSettings.loadingAnimationSeconds = 0;
        },
        enablePartialRequestPerStep() {
            // this is gonna make it so after every click on Next we submit a partial request
            this.applicationSettings.partialRequestOnEveryStep = true;
        },
        async executeCreatePartialApp() {
            if (this.applicationSettings.partialRequestsCount == 0) {
                this.applicationSettings.loadingAnimationSeconds = -1;
            }

            // we are not using/validating the recaptcha token anymore
            // const partialToken = await this.getToken('partial');
            let extraFields = {
                is_partial: true,
                // gr_token: partialToken ?? null,
                prepop_token: this.app.token ?? null,
            };

            let payload = { ...this.app, ...extraFields };

            if (this.applicationSettings.partialRequestsCount == 0) {
                await this.submitApplicationAndUpdate(payload);
            } else {
                this.submitApplicationAndUpdate(payload);
            }

            if (this.applicationSettings.partialRequestsCount == 0) {
                this.applicationSettings.loadingAnimationSeconds = 0;
            }
            this.applicationSettings.partialRequestsCount++;
        },
        async submitApplicationAndUpdate(payload) {
            const response = await formFunctions.apiSubmitApplication(payload);
            if (!!response.processedApplication) {
                if(!this.app.hasOwnProperty('unique_id') || !this.app['unique_id']) {
                    const fieldsToUpdate = {
                        unique_id: response.processedApplication.leadUniqueId ?? null
                    };
                    await this.updateApplication(fieldsToUpdate);
                }
            }
        },
        // *** REGISTRATION FLOW ***
        async executeUserWantsRegistrationDecision(skippedRegistration = null) {
            let userResponse = false;
            if (skippedRegistration === null || (typeof skippedRegistration !== 'boolean' && !skippedRegistration)) {
                let userWantsRegistration = this.getFieldValue('wants_to_create_account');
                userResponse = userWantsRegistration == 'yes';
            }
            if (!userResponse) {
                this.executeSkipRegistration();
            }
            else {
                this.applicationSettings.userWantsRegistration = true;
            }
        },
        async executeUserWantsVerificationDecision() {
            let userWantsVerification = this.getFieldValue('wants_verification');
            this.applicationSettings.userWantsVerification = userWantsVerification == 'yes';
        },
        // === END => COMPONENTS FUNCTIONS ===
        handleRecaptchaChange(recaptchaResponse) {
            this.isRecaptchaSolved = recaptchaResponse;
        },
        // evaluateConditionalText(fieldObject, textAttribute) {
        //     if (typeof fieldObject== 'function' && fieldObject.hideIfCondition({ ...this.app }) == true) {
        //             hideField = true;
        //         }

        // }
        async validateEmailWithLC(validatorElement) {

            var email = validatorElement.value;
            var knownGoodDomains = ["loanscanada.ca","gmail.com","hotmail.com","outlook.com","yahoo.com","icloud.com","yahoo.ca","live.ca","hotmail.ca","live.com","msn.com","shaw.ca","rogers.com","hotmail.fr","outlook.fr","telus.net",];
            // var validExtensions = ["com","ca","fr",];

            var emailParts = email.split('@');
            var domain = emailParts[1];
            // var tld = domain.split('.').pop();

            if (
                knownGoodDomains.includes(domain)
                // && validExtensions.includes(tld)
            ) {
                return true
            }

            var screeningEmailResponse = await
                axios.post('/portal/member/email-validation', {
                    email: validatorElement.value,
                })
                .then(res => {
                    return !!res.data.status;
                }).catch(err => {
                    return true;
                });

            if(screeningEmailResponse == true) {
                validatorElement.isValid = true;
                validatorElement.errorMessage = [];
            }
            else {
                validatorElement.isValid = false;
                validatorElement.errorMessage.push('Your email appears to be invalid.');
            }
        },
        // reCAPTCHA tests
        // async getToken(action = 'partial') {
        //     try {
        //         await this.waitForRecaptcha();
        //         const token = await grecaptcha.execute(this.recaptchaKey, { action })
        //         return token;
        //     }
        //     catch (error) {
        //         console.log('recaptcha not loaded')
        //         return null;
        //     }
        // },
        waitForRecaptcha() {
            const maxTimeout = 2000;    // 2 seconds
            const intervalTime = 100;
            let elapsedTime = 0;

            return new Promise((resolve, reject) => {
                const interval = setInterval(() => {
                    if (typeof grecaptcha !== 'undefined') {
                        clearInterval(interval);
                        resolve();
                    }
                    elapsedTime += intervalTime;
                    if (elapsedTime >= maxTimeout) {
                        clearInterval(interval);
                        reject(new Error('timeout waiting for recaptcha'));
                    }
                }, intervalTime);
            });
        },
        async doLoadingAnimation(animationTime = null, message = null) {
            // console.log('doLoadingAnimation : ' + animationTime);
            if(!animationTime || isNaN(animationTime) || animationTime <= 0) {
                return;
            }

            // convert milliseconds to seconds, just in case
            if (animationTime > 999) {
                animationTime = Math.round(animationTime / 1000);
            }


            this.applicationSettings.loadingAnimationMessage = message;
            this.applicationSettings.loadingAnimationSeconds = -1;
            let intervalLoadingAnimation = null;

            try {
                // get the animation time (in seconds) from the loading logic object
                await new Promise((resolve) => {
                    intervalLoadingAnimation = setInterval(() => {
                        animationTime--;
                        // If the animation time reaches 0, clear the interval and resolve the promise
                        if (animationTime <= 0) {
                            clearInterval(intervalLoadingAnimation);
                            resolve();
                        }
                    }, 1000);
            });

                // stop animation
                this.applicationSettings.loadingAnimationSeconds = 0;
                this.applicationSettings.loadingAnimationMessage = null;

            }
            catch (error) {
                // console.error('Error during loading animation:', error);
                clearInterval(intervalLoadingAnimation);
            }
        },
        handleUserFormInteraction() {
            this.applicationSettings.stepOnFirstUserClick = this.applicationSettings.stepOnFirstUserClick == 0 ? this.applicationSettings.progressBar.step : this.applicationSettings.stepOnFirstUserClick;
        },
        async redirectQuizToProduct() {
            // console.log('redirectQuizToProduct');
            // console.log('product');
            // console.log(this.app.product_name);

            await this.doLoadingAnimation(3);

            axios.post('/redirect-quiz', {
                ...this.app
            })
                .then(response => {
                    // res.data;
                    // validate data and redirectTo is not empty
                    window.location.href = response.data.redirectTo ?? '/loan';
                }).catch(err => {
                window.location.href = '/loan';
            });

        }
    },
    computed: {
        isValidForm() {
            let fieldsWithError = Object.values(this.validator).filter(validatorField => !validatorField.isValid);
            return (fieldsWithError && fieldsWithError.length > 0) ? false : true;
        },
        isLastStep() {
            return this.activeStepIndex == this.formData.steps.length - 1;
        },
        nextStep() {
            return this.formData.steps.hasOwnProperty(this.activeStepIndex + 1) ? this.formData.steps[this.activeStepIndex + 1] : null;
        },
        submitButtonText() {
            return this.formSettings ? this.formSettings.submitButtonText : '__next__';
        },
        skipRecaptcha() {
            return !this.showRecaptchaVerification || this.isRecaptchaSolved;
        },
        isLastApplicationStep() {
            return this.activeStep &&
                typeof this.activeStep.beforeNextStep == 'string' &&
                this.activeStep.beforeNextStep == 'executeSubmitApplication';
        },
        showSkipButtonsSection() {
            return true && (
                (this.showSkipRegistration && !!this.activeStep.isStepSkippable) ||
                this.showSkipVerification ||
                !!this.activeStep.isStepSkippable
            );
        },
    },
    created() {
        // console.log('LcForm component created');
    },
    mounted() {
        // console.log('LcForm component mounted');
        this.activeStep = this.formData.steps[this.activeStepIndex];

        // reCAPTCHA tests
        // this was used to load the reCAPTCHA script enabling its use in the getToken() method.
        // 'gr_token' is not being evaluated in the backend anymore.
        // const script = document.createElement('script');
        // script.src = 'https://www.google.com/recaptcha/api.js?render=' + this.recaptchaKey;
        // script.async = true;
        // document.head.appendChild(script);

        this.applicationSettings.partialRequestsCount = this.applicationSettings.partialRequestsCount ?? 0;
    },
    watch: {
        activeStep(value, oldValue) {
            this.checkIfLastStep();
            this.initStep();
            this.applicationSettings.progressBar.isFinalStep = !!this.isLastApplicationStep;
            this.applicationSettings.progressBar.step += 1;
        },
        hiddenFieldsIfCondition: {
            deep: true,
            // immediate: false,
            handler(hiddenFields) {
                let nullableFields = {};
                Object.keys(hiddenFields).forEach(key => {
                    if( hiddenFields[key] == true ) {
                        nullableFields[key] = null;
                        if(this.validator.hasOwnProperty(key)) {
                            this.validator[key].isValid = false;
                            this.validator[key].value = null;
                            this.validator[key].errorMessage = [];
                        }
                    }
                });
                if(Object.keys(nullableFields).length) {
                    this.updateApplication(nullableFields);
                }
            },
        },
    }

};
</script>

<style scoped>
.fade-enter-active {
    transition: opacity 1s ease;
}

.fade-leave-active {
    opacity: 0;
}

.fade-enter-from {
    opacity: 0;
}

.fade-leave-to {
    opacity: 0;
}
</style>
